import React, {createContext, useContext, useEffect, useState} from 'react';
import {ModelContext} from "../components/metadata/ModelSource";
import {getPaymentSupport} from "../api/buyAPI";

export const PaymentInfoContext = createContext({
  existCardId: '',
  ACHEnabled: '',
  currentPaymentSource:[],
  setExistCardId:() => ({}),
  setACHEnabled:() => ({}),
  setCurrentPaymentSource:() => ({}),
});

const PaymentInfoProvider = ({ children }) => {
  const [existCardId, setExistCardId] = useState('');
  const [ACHEnabled, setACHEnabled] = useState(false);
  const [currentPaymentSource, setCurrentPaymentSource] = useState([]);

  const applicationModel = useContext(ModelContext);

  useEffect(()=>{
    if (applicationModel.data && applicationModel.data.basicPolicy){
      const productVersionId = applicationModel.data.basicPolicy.productVersionIdRef;
      getPaymentSupport(productVersionId).then(res=>{
        setACHEnabled(res.data.ACHEnabled);
      });
    }
  },[])

  return (
    <PaymentInfoContext.Provider
      value={{
        existCardId,
        setExistCardId,
        ACHEnabled,
        setACHEnabled,
        currentPaymentSource,
        setCurrentPaymentSource
      }}
    >
      {children}
    </PaymentInfoContext.Provider>
  );
};

export default PaymentInfoProvider;
